<template>
  <div>
    <el-dialog v-model="dialogTableVisible" trigger="hover" :title="title" width="800" @close="close" >
      <el-form  :model="formInline" class="demo-form-inline">
        <el-form-item  label="退货数量">
          <el-input type="number" style="width: 240px" v-model="formInline.quantitys" placeholder="请输入退货数量" ></el-input>
        </el-form-item>
        <el-form-item v-if="reMarks" label="外包装图片">
          <el-upload
              auto-upload
               :on-success="getUploadUrl"
               :before-upload="handleBeforeUpload"
               v-model:file-list="formInline.outerImageOrign"
               :action="uploadUrl"
               list-type="picture-card"
               :on-preview="handlePictureCardPreview"
               :on-remove="handleRemove"
          >
            <el-icon ><Plus /></el-icon>
          </el-upload>
          <el-dialog @close="dialogVisible=false"  style="width:fit-content;max-width:90%" v-model="dialogVisible">
            <img style="width:100%" :src="dialogImageUrl" alt="Preview Image" />
          </el-dialog>
        </el-form-item>
        <el-form-item v-if="reMarks" label="设备通电图片">
          <el-upload
              auto-upload
               :on-success="getUploadUrls"
               :before-upload="handleBeforeUpload"
               v-model:file-list="formInline.equipmentImageOrign"
               :action="uploadUrl"
               list-type="picture-card"
               :on-preview="handlePictureCardPreview"
               :on-remove="handleRemoves"
          >
            <el-icon ><Plus /></el-icon>
          </el-upload>
          <el-dialog @close="dialogVisible=false" style="width:fit-content;max-width:90%" v-model="dialogVisible">
            <img style="width:100%" :src="dialogImageUrl" alt="Preview Image" />
          </el-dialog>
        </el-form-item>
        <el-form-item label="退货仓库">
          <div>
            <el-select
                v-model="formInline.receiveWarehouseId"
                filterable
                reserve-keyword
                placeholder="请选择仓库"
                remote-show-suffix
                :loading="loading"
                style="width: 240px"
                @change="handleChange"
            >
              <el-option
                  v-for="item in stockList"
                  :key="item.warehousefCode"
                  :label="item.warehouseName"
                  :value="item.id"
              />
            </el-select>
            <div class="span" >退货入库后,将不可再编辑，同时也会更改马帮对应仓库库存</div>
          </div>
        </el-form-item>
        <el-form-item >
          <el-button style="margin: 0 auto" type="primary" @click="onSubmit">{{botton}}</el-button>
        </el-form-item>

      </el-form>
    </el-dialog>
  </div>
</template>
<script >
import {ElDialog, ElForm, ElFormItem, ElButton, ElUpload, ElMessage,ElSelect,ElOption,ElIcon,ElInput} from "element-plus";
import {getFullUrl,isValidEmail,getLocalStockList} from "@/../public/js/index"
import {uploadUrl} from "@/utils/requset";
import {getReceiptInfo,addMaintenance} from "@/utils/api"
export default {
  name: "areaHouseAndQuality",
  components:{
    ElDialog,ElForm,ElFormItem,ElButton,ElUpload,ElSelect,ElOption,ElIcon,ElInput
  },
  mixins:[getFullUrl,isValidEmail],
  data(){
    return{
      dialogTableVisible:false,
      title:"退货质检|退货入库",
      botton:"保存",
      formInline:{
        sn_log_id:0,
        outerImage:[],
        outerImageOrign:[],
        equipmentImageOrign:[],
        equipmentImage:[],
        receiveWarehouseId:'',
        receiveRemarks:""
      },
      reMarks:false,
      stockList:[],
      uploadUrl:'',
      dialogVisible:false
    }
  },
  beforeMount(){
    this.uploadUrl = uploadUrl
    this.getLocalStockList()
  },
  methods:{
    getReceiptInfo(){
      getReceiptInfo({'snLogId':this.formInline.receiveSaleNumber}).then(res=>{
        console.log(res)
        if(res.Data.sn_log_id) {
          this.formInline = res.Data
        }
      }).catch(err=>{
        console.log(err)
      })
    },
    handleChange(val) {
      let stock = this.stockList.find((item) => {

        return item.id === val; // 返回2
      });
      if(stock.warehouseName=="835-美国售后仓-待报废仓" || stock.warehouseName=="836-美国售后仓-待退回国内" || stock.warehouseName=="803-美国售后仓-全新良品仓"){
        this.reMarks = true
      }else{
        this.reMarks = this.formInline.receiveRemarks &&  (this.formInline.receiveRemarks.includes('30天内退') || this.formInline.receiveRemarks.includes('不满意'))
      }
    },
    getLocalStockList(){
      getLocalStockList().then(res => {
        this.stockList = res.filter(item=>{
          return item.warehouseName.includes("美国售后仓")
        })
      })
    },
    getUploadUrl(response){
      if(!response)  return
      let url = getFullUrl(response.location)
      this.formInline.outerImageOrign[this.formInline.outerImageOrign.length-1].url = url
      this.formInline.outerImage.push(url)
    },
    getUploadUrls(response){
      if(!response)  return
      let url = getFullUrl(response.location)
      this.formInline.equipmentImageOrign[this.formInline.equipmentImageOrign.length-1].url = url
      this.formInline.equipmentImage.push(getFullUrl(response.location))
    },
    handleBeforeUpload(file){
      const isJPGOrPNG = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJPGOrPNG) {
        ElMessage.error('上传头像图片只能是 JPG/PNG 格式!');
        return false; // 不上传该文件
      } else if (file.size / 1024 / 1024 > 8) {
        ElMessage.error('图片上传大小不超过8M!')
        return false
      }
    },
    handlePictureCardPreview(uploadFile){
      this.dialogImageUrl = uploadFile.url
      this.dialogVisible = true
      return
    },
    handleRemove(uploadFile, uploadFiles){
      console.log(uploadFile, uploadFiles)
      let fullUrl = getFullUrl(uploadFile.response.location)
      this.formInline.outerImage = this.formInline.outerImage.filter(item=>{
        return  item!=fullUrl
      })
    },
    handleRemoves(uploadFile, uploadFiles){
      console.log(uploadFile, uploadFiles)
      let fullUrl = getFullUrl(uploadFile.response.location)
      this.formInline.equipmentImage = this.formInline.equipmentImage.filter(item=>{
        return  item!=fullUrl
      })
    },
    open(data){
      console.log(data)
      this.dialogTableVisible=true
      this.formInline = {
        receiveSaleType:data.receiveSaleType,
        receiveSaleNumber:data.receiveSaleNumber,
        outerImage:[],
        outerImageOrign:[],
        equipmentImageOrign:[],
        equipmentImage:[],
        receiveWarehouseId:"",
        receiveRemarks:data.receiveRemarks,
        quantitys:data.quantity,
        quantity:data.quantity
      }
      this.reMarks =data.receiveRemarks &&  (data.receiveRemarks.includes('30天内退') || data.receiveRemarks.includes('不满意'))
      this.getReceiptInfo()
    },
    onSubmit(){
      console.log(this.formInline)
      if(this.formInline.quantitys<=0 || this.formInline.quantitys>this.formInline.quantity){
        ElMessage.warning(this.$t("mobile.inStore.quantity_err"))
        return
      }
      if(this.reMarks){
        if(this.formInline.outerImage.length==0){
          ElMessage.warning('请上传外观照片')
          return
        }
        if(this.formInline.equipmentImage.length==0){
          ElMessage.warning('请上传通电设备照片')
          return
        }
      }
      if(!this.formInline.receiveWarehouseId){
        ElMessage.warning('请选择退回仓库')
        return
      }
      this.formInline.receiveWarehouse = this.stockList.filter(item=>{
        return item.id == this.formInline.receiveWarehouseId
      })
      this.formInline.receiveWarehouse = this.formInline.receiveWarehouse[0].warehouseName
      addMaintenance(this.formInline).then(res=>{
          console.log(res)
          this.dialogTableVisible=false
          ElMessage.success('保存成功')
      }).catch(err=>{
        console.log(err)
      })
    },
    close(){
      this.dialogTableVisible = false
      this.$emit('closeEdit')
    },
  }
}
</script>
<style scoped>
::v-deep .el-form-item__label{
  width: 100px;
}
.span{
  color: #f56c6c;
  font-size: 12px;
}

</style>